<form [formGroup]="remitterDetailsForm">
  <div *ngIf="!addNew">
    <div class="form-group">
      <np-mat-select-hybrid label="Ultimate Remitter"
                            [selectControl]="remitterDetailsForm.get('ultimateRemitterSelected')"
                            [data]="ultimateRemitters"
                            dataKey="id"
                            dataDisplayValue="name">
      </np-mat-select-hybrid>
      <div class="error-message"
        *ngIf="remitterDetailsForm.get('ultimateRemitterSelected').hasError('required')
              && remitterDetailsForm.get('ultimateRemitterSelected').touched">
        Please select an existing ultimate remitter or add a new one
      </div>
    </div>

    <div class="row mb-5 mt-3">
        <div class="ml-auto col-md-6">
            <button class="btn btn-block btn-lg btn-greengo" (click)="addNewUltimateRemitter()">Add new ultimate remitter</button>
        </div>
    </div>
  </div>

  <div *ngIf="addNew" [ngClass]='fullyStretchView ? "ur-form-fully-stretch": "ur-form"'>
    <div class="form-group">
      <mat-form-field
        [ngClass]="{'is-valid': remitterDetailsForm.get('remitterType').valid && remitterDetailsForm.get('remitterType').touched,
          'is-invalid': !remitterDetailsForm.get('remitterType').valid && remitterDetailsForm.get('remitterType').touched}">
        <mat-select formControlName="remitterType" placeholder="Ultimate remitter type"
          (selectionChange)="changeRemitterType()">
          <mat-option *ngFor="let item of remitterTypes" [value]="item.name">
            {{ item.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="error-message"
        *ngIf="!remitterDetailsForm.get('remitterType').valid && remitterDetailsForm.get('remitterType').touched">
        Please input valid information here
      </div>
    </div>

    <div class="form-group" *ngIf="isCompany">
      <mat-form-field
        [ngClass]="{'is-valid': remitterDetailsForm.get('remitterCompanyName').valid && remitterDetailsForm.get('remitterCompanyName').touched,
          'is-invalid': !remitterDetailsForm.get('remitterCompanyName').valid && remitterDetailsForm.get('remitterCompanyName').touched}">
        <input matInput placeholder="Ultimate remitter company name" formControlName="remitterCompanyName"  maxlength="35" />
      </mat-form-field>
      <div class="error-message"
        *ngIf="remitterDetailsForm.get('remitterCompanyName').hasError('required') && remitterDetailsForm.get('remitterCompanyName').touched">
        Please input valid information here
      </div>
      <div class="error-message"
        *ngIf="remitterDetailsForm.get('remitterCompanyName').hasError('maxlength') &&  remitterDetailsForm.get('remitterCompanyName').touched">
        Maximum of 35 characters
      </div>
      <div class="error-message"
        *ngIf="remitterDetailsForm.get('remitterCompanyName').hasError('pattern') && remitterDetailsForm.get('remitterCompanyName').touched">
        <np-swift-character-message></np-swift-character-message>
      </div>
    </div>

    <div class="form-group" *ngIf="isCompany">
      <mat-form-field
        [ngClass]="{'is-valid': remitterDetailsForm.get('remitterCompanyNumber').valid && remitterDetailsForm.get('remitterCompanyNumber').touched,
                    'is-invalid': !remitterDetailsForm.get('remitterCompanyNumber').valid && remitterDetailsForm.get('remitterCompanyNumber').touched}">
        <input matInput placeholder="Ultimate remitter company number" formControlName="remitterCompanyNumber" maxlength="50"/>
      </mat-form-field>
      <div class="error-message"
        *ngIf="remitterDetailsForm.get('remitterCompanyNumber').hasError('required') && remitterDetailsForm.get('remitterCompanyNumber').touched">
        Please input valid information here
      </div>
      <div class="error-message"
        *ngIf="remitterDetailsForm.get('remitterCompanyNumber').hasError('pattern') && remitterDetailsForm.get('remitterCompanyNumber').touched">
        <np-swift-character-message></np-swift-character-message>
      </div>
    </div>

    <div class="form-group" *ngIf="isIndividual">
      <mat-form-field
        [ngClass]="{'is-valid': remitterDetailsForm.get('remitterFirstName').valid && remitterDetailsForm.get('remitterFirstName').touched,
    'is-invalid': !remitterDetailsForm.get('remitterFirstName').valid && remitterDetailsForm.get('remitterFirstName').touched}">
        <input matInput placeholder="Ultimate remitter first name" formControlName="remitterFirstName" maxlength="35" />
      </mat-form-field>
      <div class="error-message"
        *ngIf="remitterDetailsForm.get('remitterFirstName').hasError('required') && remitterDetailsForm.get('remitterFirstName').touched">
        Please input valid information here
      </div>
      <div class="error-message"
        *ngIf="remitterDetailsForm.get('remitterFirstName').hasError('maxlength') &&  remitterDetailsForm.get('remitterFirstName').touched">
        Maximum of 35 characters
      </div>
      <div class="error-message"
        *ngIf="remitterDetailsForm.get('remitterFirstName').hasError('pattern') && remitterDetailsForm.get('remitterFirstName').touched">
        <np-swift-character-message></np-swift-character-message>
      </div>
    </div>

    <div class="form-group" *ngIf="isIndividual">
      <mat-form-field
        [ngClass]="{'is-valid': remitterDetailsForm.get('remitterLastName').valid && remitterDetailsForm.get('remitterLastName').touched,
                    'is-invalid': !remitterDetailsForm.get('remitterLastName').valid && remitterDetailsForm.get('remitterLastName').touched}">
        <input matInput placeholder="Ultimate remitter last name" formControlName="remitterLastName" maxlength="35" />
      </mat-form-field>
      <div class="error-message"
        *ngIf="remitterDetailsForm.get('remitterLastName').hasError('required') && remitterDetailsForm.get('remitterLastName').touched">
        Please input valid information here
      </div>
      <div class="error-message"
        *ngIf="remitterDetailsForm.get('remitterLastName').hasError('maxlength') &&  remitterDetailsForm.get('remitterLastName').touched">
        Maximum of 35 characters
      </div>
      <div class="error-message"
        *ngIf="remitterDetailsForm.get('remitterLastName').hasError('pattern') && remitterDetailsForm.get('remitterLastName').touched">
        <np-swift-character-message></np-swift-character-message>
      </div>
    </div>

    <div class="form-group" *ngIf="isIndividual">
      <mat-form-field
        [ngClass]="{'is-valid': remitterDetailsForm.get('remitterDOB').valid && remitterDetailsForm.get('remitterDOB').touched,
                    'is-invalid': !remitterDetailsForm.get('remitterDOB').valid && remitterDetailsForm.get('remitterDOB').touched}">
        <input matInput [matDatepicker]="pickerDOB" placeholder="Ultimate remitter DOB" formControlName="remitterDOB" />
        <mat-datepicker-toggle matSuffix [for]="pickerDOB"></mat-datepicker-toggle>
        <mat-datepicker panelClass="greengo" #pickerDOB></mat-datepicker>
      </mat-form-field>
      <div class="error-message"
        *ngIf="!remitterDetailsForm.get('remitterDOB').valid && remitterDetailsForm.get('remitterDOB').touched">
        Please input valid information here
      </div>
    </div>

    <div class="form-group">
      <mat-form-field
        [ngClass]="{'is-valid': remitterDetailsForm.get('remitterAddress').valid && remitterDetailsForm.get('remitterAddress').touched,
    'is-invalid': !remitterDetailsForm.get('remitterAddress').valid && remitterDetailsForm.get('remitterAddress').touched}">
        <input matInput placeholder="Ultimate remitter address" formControlName="remitterAddress" maxlength="35" />
      </mat-form-field>
      <div class="error-message"
        *ngIf="remitterDetailsForm.get('remitterAddress').hasError('required') && remitterDetailsForm.get('remitterAddress').touched">
        Please input valid information here
      </div>
      <div class="error-message"
        *ngIf="remitterDetailsForm.get('remitterAddress').hasError('maxlength') &&  remitterDetailsForm.get('remitterAddress').touched">
        Maximum of 35 characters
      </div>
      <div class="error-message"
        *ngIf="remitterDetailsForm.get('remitterAddress').hasError('pattern') && remitterDetailsForm.get('remitterAddress').touched">
        <np-swift-character-message></np-swift-character-message>
      </div>
    </div>

    <div class="form-group">
      <mat-form-field
        [ngClass]="{'is-valid': remitterDetailsForm.get('remitterCity').valid && remitterDetailsForm.get('remitterCity').touched,
            'is-invalid': !remitterDetailsForm.get('remitterCity').valid && remitterDetailsForm.get('remitterCity').touched}">
        <input matInput placeholder="Ultimate remitter city" formControlName="remitterCity" maxlength="50" />
      </mat-form-field>
      <div class="error-message"
        *ngIf="remitterDetailsForm.get('remitterCity').hasError('required') && remitterDetailsForm.get('remitterCity').touched">
        Please input valid information here
      </div>
      <div class="error-message"
        *ngIf="remitterDetailsForm.get('remitterCity').hasError('maxlength') &&  remitterDetailsForm.get('remitterCity').touched">
        Maximum of 50 characters
      </div>
      <div class="error-message"
        *ngIf="remitterDetailsForm.get('remitterCity').hasError('pattern') && remitterDetailsForm.get('remitterCity').touched">
        <np-swift-character-message></np-swift-character-message>
      </div>
    </div>

    <div class="form-group">
      <mat-form-field
        [ngClass]="{'is-valid': remitterDetailsForm.get('remitterPostCode').valid && remitterDetailsForm.get('remitterPostCode').touched,
            'is-invalid': !remitterDetailsForm.get('remitterPostCode').valid && remitterDetailsForm.get('remitterPostCode').touched}">
        <input matInput placeholder="Ultimate remitter post code" formControlName="remitterPostCode" maxlength="12"/>
      </mat-form-field>
      <div class="error-message"
        *ngIf="remitterDetailsForm.get('remitterPostCode').hasError('required') && remitterDetailsForm.get('remitterPostCode').touched">
        Please input valid information here
      </div>
      <div class="error-message"
        *ngIf="remitterDetailsForm.get('remitterPostCode').hasError('pattern') && remitterDetailsForm.get('remitterPostCode').touched">
        <np-swift-character-message></np-swift-character-message>
      </div>
    </div>

    <div class="form-group">
      <mat-form-field
        [ngClass]="{'is-valid': remitterDetailsForm.get('remitterState').valid && remitterDetailsForm.get('remitterState').touched,
            'is-invalid': !remitterDetailsForm.get('remitterState').valid && remitterDetailsForm.get('remitterState').touched}">
        <input matInput placeholder="Ultimate remitter state or province" formControlName="remitterState" />
      </mat-form-field>
      <div class="error-message"
        *ngIf="remitterDetailsForm.get('remitterState').hasError('required') && remitterDetailsForm.get('remitterState').touched">
        Please input valid information here
      </div>
      <div class="error-message"
        *ngIf="remitterDetailsForm.get('remitterState').hasError('pattern') && remitterDetailsForm.get('remitterState').touched">
        <np-swift-character-message></np-swift-character-message>
      </div>
    </div>

    <div class="form-group">
      <np-mat-autocomplete-hybrid
        dataDisplayValue="name" [selectControl]="remitterDetailsForm.get('remitterCountry')"
        (selecteOptionChanged)="changeRemitterCountry()"
        placeholder="Ultimate remitter country" [data]="countries"
        inputClass="capitalize-field"></np-mat-autocomplete-hybrid>
    </div>

  </div>
</form>
